import { render, staticRenderFns } from "./ManageAnnouncement.vue?vue&type=template&id=043c849c&scoped=true&"
import script from "./ManageAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ManageAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ManageAnnouncement.vue?vue&type=style&index=0&id=043c849c&prod&lang=css&"
import style1 from "./ManageAnnouncement.vue?vue&type=style&index=1&id=043c849c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c849c",
  null
  
)

export default component.exports